import "./HeaderAdsSkeleton.css";
import "../KalHome/Headerads.css";
const HeaderAdsSkeleton = () => {
  return (
    <div className="container-fluid py-4">
      <div className="row g-3">

        {/* {[1].map((i) => (
          <div key={i} className="col-12 col-sm-6 col-md-6 col-lg-4">
            <div className="leftheaderads-card-container">
              <div className="leftheaderads-skeleton-block"></div>
            </div>
          </div>
        ))} */}

        {/* Horizontal scroll placeholder */}
        <div className="col-12 col-sm-6 col-md-6 col-lg-8">
          <div className="leftheaderads-scroll-container">
            <div className="leftheaderads-scroll-content">

              {[1, 2, 3, 4, 5, 6, 7, 8].map((i) => (
                <div key={i} className="leftheaderads-card-container">
                  <div className="leftheaderads-skeleton-block"></div>
                </div>
              ))}

            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default HeaderAdsSkeleton;